import React from 'react';
import styled from 'styled-components';
import { FlexView, COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Wrapper = styled(FlexView)`
  border: 1px solid ${COLORS.GRAY_XLIGHT};
  border-radius: 8px;
`;

const StatementWrapper = styled(FlexView)`
  padding: 20px;
  background: ${COLORS.ORANGE_XXLIGHT};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const ContentWrapper = styled.div`
  padding: 16px 12px;
`;

function SupportCard({ heading, info, statement }) {
  return (
    <Wrapper>
      <ContentWrapper>
        <Text variant="h6">{heading}</Text>
        <Text variant="body2">{info}</Text>
      </ContentWrapper>
      <StatementWrapper>
        <Text variant="body2">{statement}</Text>
      </StatementWrapper>
    </Wrapper>
  );
}

export default SupportCard;
